import { ITravelBooking } from '@shared/shared/interfaces/travel.interfaces';
import * as UrlLib from '@shared/utils/url.lib';
import * as fromActions from '../actions/travel-booking.actions';

export const initialState: ITravelBooking = {
  id: null,
  url: '',
  flight_sub_bookings: [],
  car_hire_sub_bookings: [],
  hotel_sub_bookings: [],
  billing_address: '',
  use_saved_card: false,
  payment_card: false,
  cvc: '',
  save_card: false,
  amount_to_pay: '',
  amount_to_pay_currency: '',
  payment_redirect_url: '',
  payment_status: '',
  is_complete: false,
  was_successful: false,
  booking_reference: '',
};

export function reducer(state = initialState, action: fromActions.TravelBookingActions): ITravelBooking {
  switch (action.type) {
    case fromActions.RESET_TRAVEL_BOOKING:
      return initialState;

    case fromActions.CREATE_TRAVEL_BOOKING_SUCCESS: {
      const was_successful =
        action.payload.payment_status === 'done' ||
        (action.payload.payment_status === 'pending' && action.payload.has_pay_local);
      return {
        ...state,
        ...action.payload,
        id: UrlLib.extractId(action.payload.url),
        is_complete: true,
        was_successful,
      };
    }
    case fromActions.CREATE_TRAVEL_BOOKING_ERROR:
      return {
        ...state,
        ...action.payload,
        is_complete: true,
        was_successful: false,
        payment_status: 'failed',
      };
    default:
      return state;
  }
}
